import React,{ useState,useEffect } from "react";
import { Container } from "react-bootstrap";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

import { IReduxState } from "../../utils/types";

import Topbar from "../../Components/NewLayout/Topbar";
import Footer from "../../Components/NewLayout/Footer";
import LeftSidebar from "../../Components/NewLayout/LeftSidebar"; 


const LayoutContainer = () => {
  const AuthState = useSelector((state: IReduxState) => state.Auth);

  const [isMenuOpened, setIsMenuOpened] = useState<boolean>(false);
  const [leftSideBarType,setLeftSideBarType] = useState('default');

  const openMenu = () => {
    setIsMenuOpened((prevState) => !prevState);

    if (document.body) {
      if (isMenuOpened) {
        document.body.classList.remove("sidebar-enable");
      } else {
        document.body.classList.add("sidebar-enable");
      }
    }
  };

  const changeBodyAttribute = (attribute: string, value: string): void => {
    if (document.body) document.body.setAttribute(attribute, value);
  }

  useEffect(() => {
    changeBodyAttribute("data-sidebar-size", leftSideBarType);
  }, [leftSideBarType]); 

  return (
    <>
      {AuthState?.user && Object.keys(AuthState.user).length === 0 ? (
        <Navigate to="/login" />
      ) : (
        <div id="wrapper">
          <Topbar
            openLeftMenuCallBack={openMenu}
            setLeftSideBarType={setLeftSideBarType}
            leftSideBarType={leftSideBarType}
          />

          <LeftSidebar />

          <div className="content-page">
            <div className="content">
              <Container fluid>
                <Outlet />
              </Container>
            </div>

            {/* <Footer /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default LayoutContainer;